<template>
  <div>
    <img v-if="!from_admin" :src="imageUrl" alt="profile image" height="120px" width="120px" class="profile-image-upload-thumbnail"/><br/>

    <v-btn
      v-if="edit"
      type="button"
      id="upload_widget"
      color="grey"
      class="mt-3"
      small
      rounded
      outlined
    >
      Alterar Foto
      <v-icon class="ml-2"> mdi-pencil </v-icon>
    </v-btn>
    <v-btn v-else type="button" id="upload_widget" color="primary" class="mt-3" rounded outlined>Escolher foto</v-btn>

  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      imageUrl: "https://res.cloudinary.com/my-digital-assets/image/upload/v1575748479/images_cem/user-default-image_uzmjvw.png"
    }
  },

  props:['edit', 'image', 'from_admin'],

  mounted() {

    if (this.edit) {
      this.imageUrl = this.image
    }


    var myWidget = cloudinary.createUploadWidget({
        cloudName: 'my-digital-assets',
        uploadPreset: 'pfsundri',
        locale: 'pt'
      }, (error, result) => {
        if (!error && result && result.event === "success") {
          this.imageUrl = result.info.secure_url
          this.$emit('uploaded-image', this.imageUrl)
        }
      }
    )

    document.getElementById("upload_widget").addEventListener("click", function(){
        myWidget.open();
      }, false);
  },
}
</script>

<style scoped>
.profile-image-upload-thumbnail{
  object-fit: cover;
}
</style>

